/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable-line react/forbid-prop-types */
import React from "react"
import Head from "next/head"
import Layout from "components/Layout"
import TextPage from "components/Mobile/TextPage"
import { Box, Typography } from "@material-ui/core"

const AboutUsPage = () => (
  <Layout>
    <Head>
      <title>Chi Siamo</title>
    </Head>
    <TextPage
      pageTitle="Chi Siamo"
      pageContent={
        <Box>
          <p>
            Badtraveller nasce per diventare il primo portale in Italia esclusivamente dedicato al mondo della
            disabilità, all'interno del quale si possono condividere le proprie esperienze (in hotel, ristoranti,
            musei,ecc.), scambiare opinioni attraverso un forum dedicato e inviare i propri racconti di viaggio
            accessibile nell'area blog dedicata.
          </p>
          <p>
            Badtraveller vuole essere un servizio di utilità per chi ne usufruisce, è un luogo virtuale dove dar voce a
            chi finora non ha trovato un mezzo idoneo per farsi sentire, con Badtraveller non pretendiamo di abbattere
            le barriere, ma vogliamo abbassarle per far si' che tutti possano attraversarle più facilmente.
          </p>
          <Typography variant="h6">Storia</Typography>
          <p>
            Valencia è probabilmente il luogo di nascita di Badtraveller, l'idea è venuta ad uno di noi proprio li',
            immaginate un gruppo di disabili in carrozzina accompagnati da un agente di viaggio per fare 3 giorni di
            visite della città, appena arrivati in hotel una ragazza ancor prima di fare il check-in si preoccupo' di
            andare in camera per scrivere subito la sua recensione dell'albergo. Il pensiero che ha fatto nascere
            Badtraveller è stato “la sua recensione probabilmente sarà una tra le tante e forse la maggior parte degli
            utenti non la troverà neanche pertinente alle proprie esigenze, invece la sua opinione potrebbe essere
            importantissima per molti altri, diamo voce a queste persone attraverso Badtraveller!
          </p>
        </Box>
      }
    />
  </Layout>
)

export default AboutUsPage
